// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import getNewRadioInitialValues from './getNewRadioInitialValues'
import { UNCAUGHT_ERROR } from 'errors'

import {
  assembleQuery,
  fetchNewRadioCodes,
} from 'helpers/api'

const setNewRadioInitialValues = async () => {
  const initialValues = getNewRadioInitialValues()

  const details = {
    error: '',
    initialValues,
  }

  try {
    // generate a single radio code. We don't yet know if the user is trying to make a 70-90 or not.
    const query = assembleQuery([{
      field: 'isFor7090',
      value: false,
    }, {
      field: 'numberOfCodesToGenerate',
      value: 1,
    }])

    const { entities } = await fetchNewRadioCodes(query)

    // assign the generated radio code to the form's initial values.
    details.initialValues.radioCode = entities[0].generatedRadioCode
  } catch (err) {
    console.warn(err)
    details.error = err.message || UNCAUGHT_ERROR
  }

  return details
}

export default setNewRadioInitialValues
